import React, { Component } from 'react';
import './_porfolio-item.scss';


class PortfolioItem extends Component {
  constructor(props) {
    super(props);
    this.toggleClass = this.toggleClass.bind(this);
    this.loadIframe = this.loadIframe.bind(this);
    this.state = {
      sectionActive: false,
    };
  }

  componentDidMount() {
   // console.log('props did mount', this.props);
    this.loadIframe();
  }

  loadIframe() {
    document.getElementById('myIframe').src = this.props.url;
  }

  toggleClass(event) {
    const currentState = this.state.sectionActive;
    this.setState({ sectionActive: !currentState });
    event.preventDefault();
  }

  render() {
    //console.log('props', this.props);
    return (

      <section className="portfolio-item">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <h2>{this.props.title}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-21">
              <iframe src="#" title={this.props.title} id="myIframe" />
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              <div onClick={this.toggleClass} className={this.state.sectionActive ? 'description active' : 'description'}>
                <i className="fas fa-info" />
                <p className="lead">
                  {this.props.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>);
  }
}
export default PortfolioItem;



// WEBPACK FOOTER //
// ./src/components/porfolio-item/index.js